import KunLoading76 from './src/index'

KunLoading76.install = function (Vue) {
	Vue.component(KunLoading76.name, KunLoading76);
}

export default KunLoading76;
